import React from 'react'
import { createPortal } from 'react-dom'
import { Horario } from '@/types'
import { ButtonSecundario } from '../ui'
import { SeparadorTramos } from '@/icons'

interface Props {
    horarios: Horario[]
    onClose: () => void
}

const diasSemana = [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
]

const PopupVerHorarios: React.FC<Props> = ({ horarios, onClose }) => {
    // Filtra todos los horarios de un día
    const getHorariosDia = (dia: number) =>
        horarios.filter(h => Number(h.dia_semana) === dia && h.activo);

    // Función para quitar los segundos de HH:MM:SS → HH:MM
    const formatearHora = (hora: string) => hora.slice(0, 5);

    return createPortal(
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999] text-black">
            <div className="bg-zinc-200 shadow-xl rounded-md p-6 w-11/12 max-w-md max-h-[80vh] overflow-y-auto space-y-4">
                <h2 className="text-xl font-bold text-center">
                    Horarios de atención
                </h2>

                <div className="space-y-2">
                    {diasSemana.map((dia, idx) => {
                        const tramos = getHorariosDia(idx);
                        return (
                            <div key={idx} className="flex justify-between border-b border-zinc-400 pb-1 text-sm">
                                <span className="font-semibold">{dia}</span>

                                <span
                                    className={`flex items-center gap-2 font-medium ${tramos.length > 0 ? "text-blue-600" : "text-red-600"
                                        }`}
                                >
                                    {tramos.length > 0
                                        ? tramos.map((h, i) => (
                                            <React.Fragment key={i}>
                                                <span>
                                                    {formatearHora(h.hora_inicio)} – {formatearHora(h.hora_fin)}
                                                </span>
                                                {i < tramos.length - 1 && (
                                                    <SeparadorTramos className="w-6 h-2 inline-block text-green-500" />
                                                )}
                                            </React.Fragment>
                                        ))
                                        : "Cerrado"}
                                </span>
                            </div>

                        );
                    })}
                </div>

                <ButtonSecundario onClick={onClose} className="w-full mt-4">
                    Cerrar
                </ButtonSecundario>
            </div>
        </div>,
        document.body
    )
}

export default PopupVerHorarios
